import isEmpty from 'lodash.isempty';
import { hasDatePassed } from './utils';

export default function event(hit, overline) {
  const { excerpt, event_date } = hit;
  const dateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  let startDate = '';

  //If event isn't in the past, show the start date.
  if (!isEmpty(event_date)) {
    const tempStartDate = event_date.find(function(date) {
      if (date.end && !hasDatePassed(new Date(date.end))) {
        return new Date(date.start);
      }
    });

    if (tempStartDate) {
      startDate = new Date(tempStartDate.start).toLocaleDateString('en-US', dateOptions);
    }
  }

  return `
    <div class="tease tease--search">
      ${hit[overline] ? `<span class="tease__overline">${hit[overline]}</span>` : ''}
      ${startDate ? `<span class="tease__eventdate">${startDate}</span>` : ''}
      <div class='tease__inner'>
        <a class="tease__hgroup" href="${hit.url}">
          <h3 class="tease__h">
            <span class="tease__h-underline">${hit.title}</span>
          </h3>
        </a>
        ${excerpt ? `<p class="tease__desc">${excerpt}</p>` : ''}
      </div>
    </div>
  `;
}
